// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__3CUOy","menu":"style_menu__3bdMw","content":"style_content__23x2D"};